import { FC } from "react";
import { Link as LinkRouter, LinkProps as LinkPropsRouter } from "react-router-dom";
import cn from "classnames";
import styles from "./Link.module.sass";

const Link: FC<LinkPropsRouter> = ({ to, children, className, ...props }) => {
	return (
		<LinkRouter className={cn(styles.link, className)} to={to} {...props}>
			{children}
		</LinkRouter>
	);
};

export default Link;
